import { defineComponent as C, computed as u, createBlock as B, openBlock as b, unref as d, normalizeClass as i, createSlots as y, withCtx as l, renderSlot as s, normalizeProps as n, guardReactiveProps as r, createElementVNode as f, createElementBlock as g, createCommentVNode as $, createVNode as c } from "vue";
import { RevButtonIcon as w } from "@ds/components/ButtonIcon";
import { RevModalBase as T } from "@ds/components/ModalBase";
import { RevStickyBar as N } from "@ds/components/StickyBar";
import h from "../../icons/generated/IconArrowLeft.vue2.js";
import { tw as a } from "../../utils/tailwind.js";
const P = { class: "flex h-full flex-col" }, R = {
  key: 0,
  class: "w-full self-end"
}, D = /* @__PURE__ */ C({
  name: "RevDrawer",
  __name: "Drawer",
  props: {
    hasBackButton: { type: Boolean, default: !1 },
    backButtonLabel: { default: "" },
    name: {},
    title: { default: "" },
    closeButtonLabel: { default: () => {
    } },
    hasPadding: { type: Boolean, default: !0 },
    large: { type: Boolean, default: !1 },
    to: { default: "body" },
    defer: { type: Boolean, default: !1 },
    backdropZIndex: { default: () => {
    } },
    backgroundColor: { default: "mid" },
    beforeTitleClassNames: { default: "" },
    afterTitleClassNames: { default: "" },
    disableCloseOnBackdropClick: { type: Boolean, default: !1 }
  },
  emits: ["open", "close", "back"],
  setup(m) {
    const p = u(() => [
      a`h-full md:rounded-l-lg md:left-auto md:right-0 md:top-0`,
      m.large ? a`md:w-[61rem] md:max-w-full` : a`md:w-380`
    ]), k = {
      enterActiveClass: a`motion-safe:transition-transform motion-safe:duration-300`,
      enterFromClass: a`translate-y-full md:translate-x-full md:translate-y-0`,
      leaveActiveClass: a`motion-safe:transition-transform motion-safe:duration-200`,
      leaveToClass: a`translate-y-full md:translate-x-full md:translate-y-0`
    }, v = u(
      () => m.hasPadding && [a`p-24`, !m.title && a`pt-0`]
    );
    return (e, t) => (b(), B(d(T), {
      "backdrop-z-index": e.backdropZIndex,
      "background-color": e.backgroundColor,
      class: i(p.value),
      "close-button-label": e.closeButtonLabel,
      defer: e.defer,
      "disable-close-on-backdrop-click": e.disableCloseOnBackdropClick,
      "has-body-overflow": !1,
      "has-padding": !1,
      name: e.name,
      title: e.title,
      to: e.to,
      "transition-class-names": k,
      onClose: t[1] || (t[1] = (o) => e.$emit("close", o)),
      onOpen: t[2] || (t[2] = (o) => e.$emit("open"))
    }, y({
      body: l(({ close: o }) => [
        f("div", P, [
          f("div", {
            class: i(["flex-auto overflow-auto", v.value])
          }, [
            s(e.$slots, "body", n(r({ close: o })))
          ], 2),
          e.$slots.footer ? (b(), g("div", R, [
            c(d(N), {
              class: "pb-12",
              position: "bottom",
              "snap-to-view-port": !1
            }, {
              default: l(() => [
                s(e.$slots, "footer", n(r({ close: o })))
              ]),
              _: 2
            }, 1024)
          ])) : $("", !0)
        ])
      ]),
      trigger: l(({ open: o }) => [
        s(e.$slots, "trigger", n(r({ open: o })))
      ]),
      _: 2
    }, [
      e.hasBackButton || e.$slots.beforeTitle ? {
        name: "beforeTitle",
        fn: l(({ close: o }) => [
          f("div", {
            class: i(["absolute left-0 top-0", e.beforeTitleClassNames])
          }, [
            s(e.$slots, "beforeTitle", n(r({ close: o })), () => [
              c(d(w), {
                "alternative-text": e.backButtonLabel,
                icon: d(h),
                variant: "secondary",
                onClick: t[0] || (t[0] = (z) => e.$emit("back"))
              }, null, 8, ["alternative-text", "icon"])
            ])
          ], 2)
        ]),
        key: "0"
      } : void 0,
      e.$slots.afterTitle ? {
        name: "afterTitle",
        fn: l(({ close: o }) => [
          f("div", {
            class: i(["absolute right-0 top-0", e.afterTitleClassNames])
          }, [
            s(e.$slots, "afterTitle", n(r({ close: o })))
          ], 2)
        ]),
        key: "1"
      } : void 0
    ]), 1032, ["backdrop-z-index", "background-color", "class", "close-button-label", "defer", "disable-close-on-backdrop-click", "name", "title", "to"]));
  }
});
export {
  D as default
};
